function isMobile() {
    let windowWidth = window.innerWidth;
    if(windowWidth < 769) {
        return true
    } else {
        return false;
    }
}

const debounce = (f, delay) => {
    let timer = 0;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => f.apply(this, args), delay);
    }
}

// Custom sliders
const sliderReinitCallback = ([entry]) => {
    const flkty = Flickity.data(entry.target);
    if (flkty) flkty.resize();
}

const initMobileOnlySlider =(slider, args) => {
    let flickity;
    function initSlider() {
        flickity = new theme.Slideshow(slider, args);
    }

    function unload() {
        if (flickity && typeof flickity.destroy === 'function') {
            flickity.destroy();
        }
        }

    if (isMobile()) {
        initSlider();
    }

    window.addEventListener('resize', function(event) {
        if(isMobile()) {
            initSlider();
        } else {
            unload();
        }
    }, true);
}

const initCustomSlider = (slider) => {
    let args = slider.dataset.args;
    const mobileOnly = slider.dataset.mobileOnly;
    if(args) {
        args = JSON.parse(args);
    }
    if(mobileOnly == "true") {
        initMobileOnlySlider(slider, args);
    } else {
        let flickity = new theme.Slideshow(slider, args);
        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(slider);
    }
}

window.addEventListener('DOMContentLoaded', () => {

    // START TABBED COLLECTIONS
    $(document).on('click', '.tabbed-collections__tabs .btn', (e) => {
        const btn = e.currentTarget;
        const parent = btn.closest('.tabbed-collections');
        const tabID = btn.getAttribute('data-tab-id');

        let tabBtns = parent.querySelectorAll('.tabbed-collections__tabs .btn');
        let collections = parent.querySelectorAll('.tabbed-collections__collection');

        // Remove active tab
        tabBtns.forEach(elem => {
            elem.classList.remove('active');
        })
        // Remove active collection
        collections.forEach(elem => {
            elem.classList.remove('active');
        })

        // Assign new active tab
        btn.classList.add('active');
        // Assign new active collection
        collections.forEach(elem => {
            if (elem.getAttribute('data-collection-id') == tabID) {
                elem.classList.add('active');
                const slider = elem.querySelector('.custom-slider');
                if (slider) {
                    initCustomSlider(slider);
                }
            }
        })
    })
    // END TABBED COLLECTIONS

    // START HOTSPOT QUICK ADD
    const btns = document.querySelectorAll('.hotspot-add-to-cart');
    btns.forEach(btn => {
        btn.addEventListener('click', async (e) => {
            try {
                // Disable button to prevent multi-clicking
                btn.setAttribute('disabled', true);
                btn.classList.add('btn--loading');

                const var_id = btn.getAttribute('data-id');
                const prod_id = btn.getAttribute('data-prod-id');
                if (!var_id || !prod_id) {
                    throw Error() // no message required
                };
            
                // Check variant inventory via GraphQL
                const query = `{ product(id: "gid://shopify/Product/${prod_id}") { variants(first: 50) { nodes { id availableForSale quantityAvailable metafields(identifiers: [{key: "incoming_date", namespace: "custom"}]) { value key namespace } } } } }`;

                var settings = {
                    "url": theme.routes.storefrontAPI_test,
                    "method": "POST",
                    "timeout": 0,
                    "headers": {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": "949d9e512aefae21c564449dfbfe09e5"
                    },
                    "data": JSON.stringify({
                        query: query
                    })
                };

                const inventoryData = await $.ajax(settings).done(function (response) {
                    return response;
                });

                let currVar = null;
                const variantNodes = inventoryData.data.product.variants.nodes;
                for (let i = 0; i < variantNodes.length; i++) {
                    if (variantNodes[i].id.includes(var_id)) {
                        currVar = variantNodes[i];
                        break;
                    }
                }

                // Check current cart qty
                const cartData = await theme.cart.getCart();
                // const currVarInventory = inventoryData?.data?.product?.variants?.nodes?.[0]?.quantityAvailable;
                let currVarInventory = currVar.quantityAvailable;
                
                let cartQty = 0;
                for (let i = 0; i < cartData.items.length; i++) {
                    if (cartData.items[i].id == var_id) {
                        cartQty = cartData.items[i].quantity;
                        break;
                    }
                }

                // Compare values
                const availableQty = currVarInventory - cartQty;

                let data = {
                    "id": var_id,
                    "quantity": 1,
                    "properties": {}
                }
                
                if (currVarInventory > 0) {
                    data["properties"]["_inventory_quantity"] = currVarInventory;
                    if (availableQty <= 0) {
                        throw Error('All available stock is already in the cart')
                    }
                } else if (currVar.availableForSale) {
                    data["properties"]["_pre-order"] = true;

                    if (currVar?.metafields) {
                        for (let i = 0; i < currVar.metafields.length; i++) {
                            if (currVar.metafields[i].key == 'incoming_date' && currVar.metafields[i].value) {
                                data["properties"]["Dispatch From"] = currVar.metafields[i].value.split(' ')[0];
                            }
                        }
                    }
                } else {
                    throw Error('Unable to add this product')
                    return;
                }
                
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function() { 
                        document.dispatchEvent(new CustomEvent('cart:build'));
                        document.dispatchEvent(new CustomEvent('cart:open'));
                    }
                });
                // document.dispatchEvent(new CustomEvent('cart:build'));

            } catch(err) {
                alert(err?.message ? err.message : 'Something went wrong. Please check the Product Detail Page or try again later.');
            } finally {
                // Always re-enable button
                btn.removeAttribute('disabled');
                btn.classList.remove('btn--loading');
            }
        })
    });
    // END HOTSPOT QUICK ADD

    // START GRID PRODUCT QUICK ADD
    // PRE-ORDER LOGIC
    // - prevent customers from quick adding more than current avaialable inventory
    // - If inventory < 1 on page load, quick add is disabled via liquid. Proceed to PDP for Pre-Order.
    $(document).on('click', 'button.grid-product__quick-atc-btn', async (e) => {
        e.preventDefault();
        const btn = e.currentTarget;
        try {
            // Disable button to prevent multi-clicking
            btn.setAttribute('disabled', true);
            btn.classList.add('btn--loading');

            const var_id = btn.getAttribute('data-id');
            const prod_id = btn.getAttribute('data-prod-id');
            if (!var_id || !prod_id) {
                throw Error() // no message required
            };
        
            // Check variant inventory via GraphQL
            const query = `{ product(id: "gid://shopify/Product/${prod_id}") { variants(first: 50) { nodes { id availableForSale quantityAvailable metafields(identifiers: [{key: "incoming_date", namespace: "custom"}]) { value key namespace } } } } }`;

            var settings = {
                "url": theme.routes.storefrontAPI_test,
                "method": "POST",
                "timeout": 0,
                "headers": {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": "949d9e512aefae21c564449dfbfe09e5"
                },
                "data": JSON.stringify({
                    query: query
                })
            };

            const inventoryData = await $.ajax(settings).done(function (response) {
                return response;
            });

            let currVar = null;
            const variantNodes = inventoryData.data.product.variants.nodes;
            for (let i = 0; i < variantNodes.length; i++) {
                if (variantNodes[i].id.includes(var_id)) {
                    currVar = variantNodes[i];
                    break;
                }
            }

            // Check current cart qty
            const cartData = await theme.cart.getCart();
            // const currVarInventory = inventoryData?.data?.product?.variants?.nodes?.[0]?.quantityAvailable;
            let currVarInventory = currVar.quantityAvailable;
            
            let cartQty = 0;
            for (let i = 0; i < cartData.items.length; i++) {
                if (cartData.items[i].id == var_id) {
                    cartQty = cartData.items[i].quantity;
                    break;
                }
            }

            // Compare values
            const availableQty = currVarInventory - cartQty;

            let data = {
                "id": var_id,
                "quantity": 1,
                "properties": {}
            }
            
            if (currVarInventory > 0) {
                data["properties"]["_inventory_quantity"] = currVarInventory;
                if (availableQty <= 0) {
                    throw Error('All available stock is already in the cart')
                }
            } else if (currVar.availableForSale) {
                data["properties"]["_pre-order"] = true;

                if (currVar?.metafields) {
                    for (let i = 0; i < currVar.metafields.length; i++) {
                        if (currVar.metafields[i].key == 'incoming_date' && currVar.metafields[i].value) {
                            data["properties"]["Dispatch From"] = currVar.metafields[i].value.split(' ')[0];
                        }
                    }
                }
            } else {
                throw Error('Unable to add this product')
                return;
            }
              
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function() { 
                    document.dispatchEvent(new CustomEvent('cart:build'));
                    document.dispatchEvent(new CustomEvent('cart:open'));
                }
            });
            // document.dispatchEvent(new CustomEvent('cart:build'));

        } catch(err) {
            alert(err?.message ? err.message : 'Something went wrong. Please check the Product Detail Page or try again later.');
        } finally {
            // Always re-enable button
            btn.removeAttribute('disabled');
            btn.classList.remove('btn--loading');
        }
    })
    // END GRID PRODUCT QUICK ADD
  
    // Copy text/url to clipboard
    const copyToClipboardBtns = document.querySelectorAll('.js-copy-to-clipboard');
    if(copyToClipboardBtns.length > 0) {
        copyToClipboardBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                const text = e.target.getAttribute('data-text');
                navigator.clipboard.writeText(text);
                const notificationEl = e.target.parentNode.querySelector('.text-copied-alert');
                notificationEl.classList.remove('hide');
                setTimeout(function() {
                    notificationEl.classList.add('hide');
                },3000);
            });
        })
    }

    // Custom sliders
    const sliderReinitCallback = ([entry]) => {
        const flkty = Flickity.data(entry.target);
        if (flkty) flkty.resize();
    }

    const initMobileOnlySlider =(slider, args, evtListen) => {
        let flickity;

        function initSlider() {
            flickity = new theme.Slideshow(slider, args);
            // Used for product page image slider on variant update
            if(evtListen) {

                document.addEventListener('updateVisibleSlide', (e) => {
                    flickity.goToSlide(e.detail.id);
                });

                document.dispatchEvent(new CustomEvent('customSlideLoaded'));
                
            }
        }

        function unload() {
            if (flickity && typeof flickity.destroy === 'function') {
              flickity.destroy();
            }
          }

        if (isMobile()) {
            initSlider();
        }

        window.addEventListener('resize', function(event) {
            if(isMobile()) {
                initSlider();
            } else {
                unload();
            }
        }, true);
    }

    const initCustomSlider = (slider, evtListen) => {
        let args = slider?.dataset?.args;
        const mobileOnly = slider?.dataset?.mobileOnly;
        if(args) {
            args = JSON.parse(args);
        }
        if (mobileOnly && mobileOnly == "true") {
            initMobileOnlySlider(slider, args, evtListen);
        } else {
            let flickity = new theme.Slideshow(slider, args);
            const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
            reinitFlickitySlider.observe(slider);
            // Used for product page image slider on variant update
            if(evtListen) {
                document.addEventListener('updateVisibleSlide', (e) => {
                    flickity.goToSlide(e.detail.id);
                });

                document.dispatchEvent(new CustomEvent('customSlideLoaded'));
            }
        }
    }
    document.addEventListener('initCustomSlider', (evt) => {
        initCustomSlider(evt.detail);
    })

    const blogSliders =  document.querySelectorAll('.blog-slider');

    blogSliders.forEach(blogslider => {
        
        initCustomSlider(blogslider);
    })

    const gallerySliders =  document.querySelectorAll('.gallery-slider');

    gallerySliders.forEach(gallerySlider => {
        
        initCustomSlider(gallerySlider);

        if ( gallerySlider.querySelectorAll('.article-grid').length <= 3 ) {
            
            if ( gallerySlider.querySelector('.flickity-page-dots') ) {
                gallerySlider.querySelector('.flickity-page-dots').style.display = 'none';
            }
        }
    })

    const vipSliders =  document.querySelectorAll('.vip-slider');

    vipSliders.forEach(vipSlider => {
        
        initCustomSlider(vipSlider);
    })

    const boxSliders =  document.querySelectorAll('.box-slider');

    boxSliders.forEach(boxSlider => {
        
        initCustomSlider(boxSlider);
    })

    const colourSliders =  document.querySelectorAll('.colour-slider');

    colourSliders.forEach(colourSlider => {
        initCustomSlider(colourSlider);
    })

    const pdpGallerySliders =  document.querySelectorAll('.product__photos--grid');

    pdpGallerySliders.forEach(pdpGallerySlider => {
        
        initCustomSlider(pdpGallerySlider, true);
    })

    const customSliders = document.querySelectorAll('.custom-slider');

    if(customSliders.length) {
        customSliders.forEach(slider => {
            initCustomSlider(slider);
        })
    }

    // Cart upsell
    document.addEventListener('cart:ready', () => {
        const cartUpsellSliders = document.querySelectorAll('.cart-upsell--slider');
        if (cartUpsellSliders.length > 0) {
            cartUpsellSliders.forEach(cartUpsellSlider => {
                setTimeout(function() {
                    initCustomSlider(cartUpsellSlider);
                },400);
            });
        }

        const cartUpsellVariantSelect = document.querySelectorAll('.cart-upsell--slider .variant-input-wrap select');
        if(cartUpsellVariantSelect.length) {
            cartUpsellVariantSelect.forEach(select => {
                select.addEventListener('change', (e) => {
                    const parent = e.target.closest('.cart-upsell--content');
                    const priceElem = parent.querySelector('.price');
                    const selectedOptionName = e.target.value;
                    const selectedOption = parent.querySelector(`option[value="${selectedOptionName}"]`);
                    const variantId = selectedOption.getAttribute('data-variant-id');
                    const atcBtn = parent.querySelector('.cart-upsell-slider__add-to-cart');
                    atcBtn.setAttribute('data-id', variantId);

                    if(priceElem) {
                        const price = theme.Currency.formatMoney(selectedOption.getAttribute('data-price'), theme.settings.moneyFormat)
                        priceElem.innerText = `${price}`;
                    }
                })
            })
        }
    });

    const addUpsellToCart = (e) => {
        let id = e.target.getAttribute('data-id');
        let props = e.target.getAttribute('data-props');
        e.target.classList.add('btn--loading');
        let formData = {
            'items': [{
                'id': id,
                'quantity': 1
            }]
        };
        if(props) {
            formData = {
                'items': [{
                    'id': id,
                    'quantity': 1,
                    'properties': JSON.parse(props)
                }]
            }
        }
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:updated')); // trigger FST update
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    $(document).on('click', '.cart-upsell-slider__add-to-cart', (e) => {
        e.preventDefault();
        if (e.currentTarget.hasAttribute('disabled')) {
            return;
        }
        addUpsellToCart(e);
    });

    // START FILTER MENU
    $(document).on('click', '.reveal-hidden-filters', (e) => {
        const btn = e.currentTarget;
        const list = btn.closest('ul');
        const extra_filters = list.querySelectorAll('.hidden-filter');
        const hr = list.querySelector('hr');
        const filterId = btn.dataset.filterId;

        // Reveal additional filters
        btn.style.display = 'none';
        hr.style.display = 'none';

        extra_filters.forEach(filter => {
            filter.classList.remove('hidden-filter');
        })

        // Update accordion height
        const wrapper = list.closest('.collapsible-content__inner');
        const wrapper_height = wrapper.offsetHeight;

        const accordion_panel = list.closest('.collapsible-content');

        accordion_panel.style.height = `${wrapper_height}px`;

        // Check and set session storage for open filters
        const plpFilterOpen = sessionStorage.getItem('plpFilterOpen');
        if(plpFilterOpen) {
            const plpFilterArray = plpFilterOpen.split(',');
            let isInArray = false;
            plpFilterArray.forEach(filter => {
                if(filter === filterId) {
                    isInArray = true;
                }
            })
            if(!isInArray) {
                sessionStorage.setItem('plpFilterOpen', plpFilterOpen + ',' + filterId);
            }
        } else {
            sessionStorage.setItem('plpFilterOpen', filterId);
        }
    })
    
    document.addEventListener('collection:reloaded', function() {
        const plpFilterOpen = sessionStorage.getItem('plpFilterOpen');
        if(plpFilterOpen) {
            const plpFilterArray = plpFilterOpen.split(',');
            plpFilterArray.forEach(filter => {
                const isOpen = document.querySelector(`.collapsible-content[data-collapsible-id="${filter}"]`).classList.contains('is-open');
                const filterButton = document.querySelector(`.reveal-hidden-filters[data-filter-id="${filter}"]`);
                if(isOpen && filterButton) {
                    document.querySelector(`.reveal-hidden-filters[data-filter-id="${filter}"]`).click();
                }
            })
        }
    });

    // FAQ
    const faqNav = document.querySelectorAll('.tab-nav button');
    const tabContent = document.querySelectorAll('.tab-content');
    const tabContentImage = document.getElementById("tab-content_image");

    if ( faqNav.length ) {

        faqNav.forEach(nav => {

            nav.addEventListener('click', (e) => {
                const self = e.target;

                // inactive all button
                faqNav.forEach(nav => {
                    nav.closest('li').classList.remove('active');
                });

                // set banner
                if ( tabContentImage ) {
                    tabContentImage.src = self.dataset.banner;
                }

                // close all
                tabContent.forEach(tab => {
                    tab.classList.remove('open');

                    // open selected
                    if ( tab.dataset.parent == self.dataset.parent ) {
                        tab.classList.add('open')
                    }
                })

                // active selected
                self.closest('li').classList.add('active');
            })
        })
    }

    if (faqNav[0]) {
        faqNav[0].click();
    }

    // shopify form app b2b wholesale form
    function formStyle() {
        const shadowRootOne = document.getElementById('app-embed');
        const styleElement = document.createElement('style');

        if ( shadowRootOne ) {
            
            styleElement.innerText = ` 
            :host{--inline-container-max-width:100%;
                --container-text-alignment:left;}legend {padding-top: 2em !important;}
                ._checkboxLegend_171zd_18 {
                    display: none !important;
                }

                [name="custom#terms__conditions"] {
                    margin: .5em 0 !important;
                }

                button._formSubmitButton_16kdc_81 {
                    position: relative !important;
                    font-weight: 600 !important;
                    text-transform: uppercase !important;
                    font-size: 12px !important;
                    transition: all .2s ease !important;
                }

                button._formSubmitButton_16kdc_81:after {
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    border-bottom: 1px solid;
                }

                button._formSubmitButton_16kdc_81:hover {
                    background-color: #000000;
                    color: #ffffff;
                }
            `;
            shadowRootOne.shadowRoot.appendChild(styleElement);
          
            clearInterval(checkerForm);
        }
    }

    const checkerForm = setInterval(formStyle, 1000);

    // START PDP META CONTENT
    $(document).on('click', '.product-meta-content__button', (e) => {
        const btn = e.currentTarget;

        const parent = btn.closest('.product-meta-content');
        const meta_id = btn.getAttribute('data-id');
        const target_panel = parent.querySelector(`.product-meta-content__panel[data-id="${meta_id}"]`);

        // Deactivate all buttons
        const deactivateButtons = () => {
            const btns = parent.querySelectorAll('.product-meta-content__button');
            btns.forEach(btn => {
                btn.classList.remove('active');
            });
        };

        // Deactivate all panels
        const deactivatePanels = () => {
            const panels = parent.querySelectorAll('.product-meta-content__panel');
            panels.forEach(panel => {
                panel.classList.remove('active');
            });
        };

        if (btn.classList.contains('active')) {
            deactivateButtons();
            deactivatePanels();
            return;
        };

        deactivateButtons();
        deactivatePanels();

        // Activate target button and panel
        btn.classList.add('active');
        target_panel.classList.add('active');
    })
    // END PDP META CONTENT

    // START PDP ALSO AVAILABLE IN
    theme.GraphQL = {

        config:  {
            storefront_token: '949d9e512aefae21c564449dfbfe09e5',
            request_url: theme.routes.storefrontAPI_test
        },

        sendRequest: function(request, request_group, output_container, temp_data) {
            if(this.config[request_group] == null) {
                this.config[request_group] = 1;
            } else {
                this.config[request_group]++;
            }

            let return_response = null;

            let settings = {
                'crossDomain': true,
                'url': this.config.request_url,
                'method': 'POST',
                'headers': {
                    'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                    'Content-Type': 'application/graphql',
                },
                'data': request,
                'success': function(response) {
                    theme.GraphQL.config[request_group]--;
                    return_response = response;
                },
                'error': function(xhr, errDesc) {
                    theme.GraphQL.config[request_group]--;
                    console.log(errDesc);
                }
            };
            $.ajax(settings)
                .done(function() {
                    if(request_group === "also-available") {
                        if (temp_data.request_type == 'size') {
                            theme.AlsoAvailableIn_Size.buildSizeOutput(return_response);
                        }
                        if (temp_data.request_type == 'colour') {
                            theme.AlsoAvailableIn_Colour.buildColourOutput(return_response, temp_data);
                        }
                    }
                    theme.GraphQL.cleanUp(request_group);
                });
        },

        getGraphQLResponse: async function(request, request_group) {
            if(this.config[request_group] == null) {
                this.config[request_group] = 1;
            } else {
                this.config[request_group]++;
            }

            let return_response = null;

            let settings = {
                'crossDomain': true,
                'url': this.config.request_url,
                'method': 'POST',
                'headers': {
                    'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                    'Content-Type': 'application/graphql',
                },
                'data': request,
                'success': function(response) {
                    theme.GraphQL.config[request_group]--;
                    return_response = response;
                },
                'error': function(xhr, errDesc) {
                    theme.GraphQL.config[request_group]--;
                    console.log(errDesc);
                }
            };

            return $.ajax(settings);
        },

        cleanUp: function(request_group) {
            if(theme.GraphQL.config[request_group] < 1) {
                $('body').trigger(request_group+":loaded");
                delete this.config[request_group];
            }
        }
    };

    theme.AlsoAvailableIn_Size = (function() {
        let config = {
            request_type: '',
            request_query: '',
            current_product: '',
            product_name: '',
            image_url_structure: '',
        };

        async function init(container) {
            let $container = this.$container = $(container);
            config.request_type = $container.data('request-type');
            config.request_query = $container.data('request-query').replaceAll('&quot;', '\"');
            config.current_product = $container.data('current-product');
            config.product_name = $container.data('product-name');
            config.image_url_structure = $container.data('image-url-structure');

            config.request_query = config.request_query.replaceAll('"', '\\\"');

            let hasNextPage = true;
            let cursor = null;
            let $response = null;

            try {
                while (hasNextPage) {
                    const query = `
                    {
                        products(first: 100${cursor ? `, after: "${cursor}"` : ''}, query: "tag:`+config.request_query+`") {
                            edges {
                                cursor
                                node {
                                    availableForSale
                                    title
                                    handle
                                    tags
                                    metafields(identifiers: [{ key: \"alternate_product_title\", namespace: \"custom\" }]) {
                                        namespace
                                        key
                                        value
                                    }
                                }
                            }
                            pageInfo {
                                hasNextPage
                            }
                        }
                    }
                    `;

                    const response = await theme.GraphQL.getGraphQLResponse(query, 'also-available', config);
                    const data = response.data;
                    const edges = data.products.edges;

                    if (!$response) {
                        $response = response;
                    } else {
                        const _edges = $response.data.products.edges.concat(edges);
                        $response.data.products.edges = _edges;
                    }

                    hasNextPage = data.products.pageInfo.hasNextPage;

                    if (hasNextPage) {
                        cursor = edges[edges.length - 1].cursor;
                    }
                }

                if (!$response) {
                    theme.GraphQL.cleanUp("also-available");
                    return;
                }

                if (config.request_type == 'size') {
                    theme.AlsoAvailableIn_Size.buildSizeOutput($response);
                } else if (config.request_type == 'colour') {
                    theme.AlsoAvailableIn_Colour.buildColourOutput($response, config);
                }
            } catch (err) {
                console.error("Errors in GraphQL: "+err);
            }
        }

        function buildSizeOutput(response) {
            let output_html = '';
            let product_arr = response.data.products.edges;

            if(product_arr.length <= 1) {
                return;
            }

            this.$container.show();

            let filteredProducts = product_arr.filter(p => {
                return !p.node.tags.includes('hidden')
            });
            const regex = /\(([^)]+)\)/;
            
            // Quick run to add the SKU tag as data to the product node
            filteredProducts.forEach(item => {
                const tags = item.node.tags;
                const skuTag = tags.find(tag => tag.startsWith("SKU_"));
                if (skuTag) {
                    item.node.SKU = skuTag.split("SKU_")[1];
                }
            });

            // ensure only searched for SKUs remain
            filteredProducts = product_arr.filter(p => {
                return config.request_query.includes(p.node.SKU)
            });
            
            // Create a mapping of SKU to index for sorting
            let skuSortedArray = this.$container.data("request-products");
            const skuIndexMap = skuSortedArray.reduce((acc, sku, index) => {
                acc[sku] = index;
                return acc;
            }, {});
            
            // Sort dataToSort array based on the order of SKUs in sortedArray
            filteredProducts.sort((a, b) => {
                const aSku = a.node.SKU;
                const bSku = b.node.SKU;
                return skuIndexMap[aSku] - skuIndexMap[bSku];
            });

            // Builds swatches products
            output_html = filteredProducts.map(p => {
                let size_name = p.node.title;
                for (let i = 0; i < p.node.metafields.length; i++) {
                    if (p.node.metafields[i]?.key == 'alternate_product_title') {
                        size_name = p.node.metafields[i].value;
                    }
                }

                return `
                    <a
                        class="product-swatch-button${ p.node.handle === config.current_product ? ' aa-swatch--current' : ''}"
                        href="/products/${p.node.handle}"
                        title="${size_name}">
                            ${size_name}
                    </a>
                `;
            }).join('');

            // Select current swatch and displays colour name
            const currentSwatch = filteredProducts.find(p => p.node.handle === config.current_product);
            if (currentSwatch) {
                let matches = regex.exec(currentSwatch.node.title);
                this.$container.find('#current-product-size').append(matches);
            }

            this.$container.find('.aa-container').append(output_html);
        }

        return {
            init: init,
            buildSizeOutput: buildSizeOutput
        };

    })();

    theme.AlsoAvailableIn_Colour = (function() {
        let config = {
            request_type: '',
            request_query: '',
            current_product: '',
            product_name: '',
            image_url_structure: '',
        };

        function init(container) {
            let $container = this.$container = $(container);
            config.request_type = $container.data('request-type');
            config.request_query = $container.data('request-query').replaceAll('&quot;', '\"');
            config.current_product = $container.data('current-product');
            config.product_name = $container.data('product-name');
            config.image_url_structure = $container.data('image-url-structure');

            config.request_query = config.request_query.replaceAll('"', '\\\"');

            let cursor = null;

            let all_response = null;
            let hasNextPage = true;

            async function getAllProducts() {
                try {
                    while (hasNextPage) {
                        const query = `
                        {
                            products(first: 250${cursor ? `, after: "${cursor}"` : ''}, query: "tag:`+config.request_query+`") {
                                pageInfo {
                                    hasNextPage
                                }
                                edges {
                                    cursor
                                    node {
                                        availableForSale
                                        title
                                        handle
                                        tags
                                        metafields(identifiers: [{ key: \"Colour\", namespace: \"custom\" }]) {
                                            namespace
                                            key
                                            value
                                        }
                                    }
                                }
                            }
                        }
                        `;
                        const response = await theme.GraphQL.getGraphQLResponse(query, 'also-available', config);
                        const data = response.data;
                        const edges = data.products.edges;

                        hasNextPage = data.products.pageInfo.hasNextPage;

                        if (hasNextPage) {
                            cursor = edges[edges.length - 1].cursor;
                        }

                        if (!all_response) {
                            all_response = response;
                        } else {
                            const _edges = all_response.data.products.edges.concat(edges);
                            all_response.data.products.edges = _edges;
                        }
                    }
                } catch (err) {
                    throw new Error("Errors in GraphQL: "+err);
                }

                return all_response;
            }

            getAllProducts()
                .then(response => {
                    if (!response) {
                        theme.GraphQL.cleanUp("also-available");
                        return;
                    }

                    if (config.request_type == 'size') {
                        theme.AlsoAvailableIn_Size.buildSizeOutput(response);
                    } else if (config.request_type == 'colour') {
                        theme.AlsoAvailableIn_Colour.buildColourOutput(response, config);
                    }
                })
                .catch(err => {
                    console.error("Errors in GraphQL: "+err);
                })
                .finally(() => {
                    theme.GraphQL.cleanUp('also-available');
                });
        }

        async function getDataFromCSV() {
            return new Promise((resolve, reject) => {
                let url = "//www.hueseeka.com.au/cdn/shop/files/colour_swatches.csv?v=11494696352813898455";
                const strURl = String(url);
                const start = strURl.slice(0, 2);
                if (start == '//') {
                    url = strURl.slice(2, strURl.length);
                    url = url.replace('www.', 'https://');
                }
                Papa.parse(url, {
                    download: true,
                    delimiter: ",",
                    header: true,
                    complete: (results) => {
                        resolve(results);
                    },
                    error: function(error) {
                        reject(error);
                    }
                });
            });
        }

        async function buildColourOutput(response, temp_data) {
            const csvData = await getDataFromCSV();

            let output_html = '';
            let product_arr = response.data.products.edges;

            if(product_arr.length <= 1) {
                return;
            }

            this.$container.show();

            let filteredProducts = product_arr.filter(p => {
                return !p.node.tags.includes('hidden')
            });
            const regex = /\(([^)]+)\)/;
            
            // Quick run to add the SKU tag as data to the product node
            filteredProducts.forEach(item => {
                const tags = item.node.tags;
                const skuTag = tags.find(tag => tag.startsWith("SKU_"));
                if (skuTag) {
                    item.node.SKU = skuTag.split("SKU_")[1];
                }
            });

            // ensure only searched for SKUs remain
            filteredProducts = product_arr.filter(p => {
                return config.request_query.includes(p.node.SKU)
            });
            
            // Create a mapping of SKU to index for sorting
            let skuSortedArray = this.$container.data("request-products");
            const skuIndexMap = skuSortedArray.reduce((acc, sku, index) => {
                acc[sku] = index;
                return acc;
            }, {});
            
            // Sort dataToSort array based on the order of SKUs in sortedArray
            filteredProducts.sort((a, b) => {
                const aSku = a.node.SKU;
                const bSku = b.node.SKU;
                return skuIndexMap[aSku] - skuIndexMap[bSku];
            });

            // Builds swatches products
            output_html = filteredProducts.map(p => {
                let colour_name = p.node.title;
                for (let i = 0; i < p.node.metafields.length; i++) {
                    if (p.node.metafields[i]?.key == 'Colour') {
                        colour_name = p.node.metafields[i].value;
                    }
                }

                // Add image name to node
                const title_down = colour_name.toLowerCase();
                for (let i = 0; i < csvData.data.length; i++) {
                    if (title_down == csvData.data[i]["Colour Name"].toLowerCase()) {
                        p.node.img_name = csvData.data[i].PNG;
                    }
                }

                return `
                    <a
                        class="product-swatch-button product-swatch-button--colour${ p.node.handle === config.current_product ? ' aa-swatch--current' : ''}${ p.node.availableForSale ? '' : ' sold-out'}"
                        href="/products/${p.node.handle}"
                        title="${colour_name}${ p.node.availableForSale ? '' : ' (Sold Out)'}"
                        style="background-image: url('${temp_data.image_url_structure.replace('colour----productTitle---', p.node.img_name)}'); background-size: cover; background-position: center;"
                    >
                        
                    </a>
                `;
            }).join('');

            // Select current swatch and displays colour name
            const currentSwatch = filteredProducts.find(p => p.node.handle === config.current_product);
            if (currentSwatch) {
                let matches = regex.exec(currentSwatch.node.title);
                this.$container.find('#current-product-size').append(matches);
            }

            this.$container.find('.aa-container').append(output_html);
        }

        return {
            init: init,
            buildColourOutput: buildColourOutput
        };

    })();

    $(document).ready(function() {
        $('[data-section-type="also-available--size"]').each(function() {
            theme.AlsoAvailableIn_Size.init(this);
        });
    });
    $(document).ready(function() {
        $('[data-section-type="also-available--colour"]').each(function() {
            theme.AlsoAvailableIn_Colour.init(this);
        });
    });

    $(document).on('mouseenter', '.product-swatch-button', (e) => {
        let wrapper = e.target.closest('.aa-wrapper');
        let label_current = wrapper.querySelector('.current-colour');

        let title = e.currentTarget.getAttribute('title');

        if (label_current && title) {
            label_current.innerHTML = title;
        }
    })
    $(document).on('mouseenter', '.product-swatch-button', (e) => {
        let wrapper = e.target.closest('.aa-wrapper');
        let label_current = wrapper.querySelector('.current-size');

        let title = e.currentTarget.getAttribute('title');

        if (label_current && title) {
            label_current.innerHTML = title;
        }
    })

    $(document).on('mouseleave', '.product-swatch-button', (e) => {
        let wrapper = e.target.closest('.aa-wrapper');
        let label_current = wrapper?.querySelector('.current-colour');

        let title = wrapper.querySelector('.product-swatch-button.aa-swatch--current')?.getAttribute('title');

        if (label_current) {
            if (title) {
                label_current.innerHTML = title;
            } else {
                label_current.innerHTML = ''; // not on base pack size product, show nothing
            }
        }
    })
    // END PDP ALSO AVAILABLE IN

    // START PLP FILTER TREE
    // Hide tree
    $(document).on('click', '#hide-filter-tree', (e) => {
        const btn = e.currentTarget;

        const grid = btn.closest('.grid');
        if (!grid) return;

        const products = grid.querySelector('.grid__item--content');
        const sidebar = grid.querySelector('.grid__item--sidebar');
        const showTreeBtn = grid.querySelector('#show-filter-tree');
        if (!products || !sidebar || !showTreeBtn) return;

        sidebar.style.display = "none";

        products.classList.add('medium-up--whole');
        products.classList.remove('medium-up--three-quarters');

        btn.classList.add('hidden');
        showTreeBtn.classList.remove('hidden');
    })

    // Show tree
    $(document).on('click', '#show-filter-tree', (e) => {
        const btn = e.currentTarget;

        const grid = btn.closest('.grid');
        if (!grid) return;

        const products = grid.querySelector('.grid__item--content');
        const sidebar = grid.querySelector('.grid__item--sidebar');
        const hideTreeBtn = grid.querySelector('#hide-filter-tree');
        if (!products || !sidebar || !hideTreeBtn) return;

        sidebar.style.display = "block";

        products.classList.add('medium-up--three-quarters');
        products.classList.remove('medium-up--whole');

        btn.classList.add('hidden');
        hideTreeBtn.classList.remove('hidden');
    })

    // Auto-collapse filters
    $(document).on('click', '.collection-sidebar .collapsible-trigger', (e) => {
        const btn = e.currentTarget;

        const parent = btn.closest('form');
        const allTriggers = parent.querySelectorAll('.collapsible-trigger');

        allTriggers.forEach(trigger => {
            if (trigger != btn) {
                // manually close
                trigger.classList.remove('is-open');
                trigger.setAttribute('aria-expanded', 'false');

                const panel = trigger.nextElementSibling;
                if (panel) {
                    panel.classList.remove('is-open');
                    panel.style.height = "0px";
                }
            }
        })
    })
    // END PLP FILTER TREE
});

// Shop the look filters
document.addEventListener('DOMContentLoaded', () => {
    const shopTheLookFilters = document.querySelector('.shop-the-look-filter-form');
    if(shopTheLookFilters) {
        const filters = document.querySelectorAll('.shop-the-look-filter-form input');

        const renderShopTheLook = (data) => {
            const container = document.querySelector('.js-shop-the-look-grid');
            const paginationContainer = document.querySelector('.pagination');
            const articles = data.data.blogByHandle.articles.edges;
            const blogHandle = data.data.blogByHandle.handle;
            const imageSize = container.dataset.imageSize;
            let containerHtml = '';
            let paginationHtml = '';
            if(articles.length) {
                articles.forEach(article => {
                    const articleHandle = article.node.handle;
                    const title = article.node.title;
                    let image = '';
                    if(article.node.image) {
                        image = `
                            <a href="/blogs/${blogHandle}/${articleHandle}" class="article__grid-image" aria-label="${title}">
                                <div class="image-wrap loaded">
                                    <div class="grid__image-ratio grid__image-ratio--${imageSize}">
                                        <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
                                            <img src="${article.node.image.url}" alt="${article.node.image.alt}" loading="lazy" class="image-element"></img>
                                        </image-element>
                                    </div>
                                </div>
                            </a>
                        `;
                    }
                    containerHtml += `
                        <div class="article-grid grid__item medium-up--one-quarter one-half aos-init aos-animate" data-aos="row-of-4">
                            <div class="article-grid_inner">
                                <div class="top">
                                    <div class="grid grid--small">
                                        <div class="grid__item one-whole">
                                            ${image}
                                        </div>
                                        <div class="grid__item one-whole">
                                            <div class="article__grid-meta">
                                                <div class="article__date"></div>
                                                <a href="/blogs/${blogHandle}/${articleHandle}" class="article__title">${title}</a>
                                                <br>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <a href="/blogs/${blogHandle}/${articleHandle}" class="btn btn--link">Shop now</a>
                                </div>
                            </div>
                        </div>
                    `;
                });

                const pageInfo = data.data.blogByHandle.articles.pageInfo;

                if(pageInfo.hasPreviousPage) {
                    paginationHtml += `
                    <span class="prev js-pagination" data-cursor="${pageInfo.startCursor}" data-pagination="prev">
                        <a title="Previous">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"/></svg>
                            <span class="icon__fallback-text">Next</span>
                        </a>
                    </span>
                `;
                }

                if(pageInfo.hasNextPage) {
                    paginationHtml += `
                        <span class="next js-pagination" data-cursor="${pageInfo.endCursor}" data-pagination="next">
                            <a title="Next">
                                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><title>icon-chevron</title><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"></path></svg>
                                <span class="icon__fallback-text">Next</span>
                            </a>
                        </span>
                    `;
                }

            } else {
                containerHtml = '<p class="no-products text-center">No collections to show based on selected filters</p>';
            }
            container.innerHTML = containerHtml;
            paginationContainer.innerHTML = paginationHtml;
        }

        const addSelectedFilters = () => {
            const container = document.querySelector('.tag-list--active-tags');       
            const selectedFiltersInputs = document.querySelectorAll('.shop-the-look-filter-form input:checked');
            let filtersHtml = '';

            if(selectedFiltersInputs.length) {
                selectedFiltersInputs.forEach(filter => {
                    if(filter.value != "" && filter.value.startsWith('_')) {
                        const filterName = filter.value.replace('_', "").replaceAll('-', " ").replace('_', ": ");
                        filtersHtml += `<li class="tag tag--remove js-filter-remove" data-filter="${filter.value}"><a class="tag--remove__link">${filterName}</a>
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg></li>`;
                    }
                });
            }
            container.innerHTML = filtersHtml;
        }

        const getSelectedFilters = () => {
            const selectedFiltersInputs = document.querySelectorAll('.shop-the-look-filter-form input:checked');
            let selectedFilters = [];
            if(selectedFiltersInputs.length) {
                selectedFiltersInputs.forEach(filter => {
                    if(filter.value != "") {
                        selectedFilters.push(filter.value);
                    }
                })
            };

            let tag_query = "";
            selectedFilters.forEach(filter => {
                if(tag_query == "") {
                    tag_query += `tag:${filter}`;
                } else {
                    tag_query += ` AND tag:${filter}`;
                }
            })

            return tag_query;
        }

        const removeSelectedFilter = (e) => {
            const selectedFiltersInputs = document.querySelectorAll('.shop-the-look-filter-form input:checked');
            if(selectedFiltersInputs.length) {
                selectedFiltersInputs.forEach(filter => {
                    if(filter.value == e.target.dataset.filter) {
                        filter.checked = false;
                        addSelectedFilters();
                        getFilteredBlogs();
                    }
                })
            }
            
        }

        const getFilteredBlogs = async (cursor, cursorType) => {
            const tag_query = getSelectedFilters();
            let query = `"${tag_query}", first: 16`;
            const blogType = shopTheLookFilters.dataset.blogHandle;
            const storefront_token = '949d9e512aefae21c564449dfbfe09e5';
            const request_url = theme.routes.storefrontAPI;

            if(cursor && cursorType === 'next') {
                query = `"${tag_query}", after: ${cursor == null ? null : '"' + cursor + '"'}, first: 16`;
            } else if (cursor && cursorType === 'prev') {
                query = `"${tag_query}", before: ${cursor == null ? null : '"' + cursor + '"'}, last: 16`;
            }

            try {
                const res = await fetch(request_url, {
                    method: 'POST',
                    headers: {
                      'X-Shopify-Storefront-Access-Token': storefront_token,
                      'Content-Type': 'application/graphql',
                    },
                    body: `{
                        blogByHandle(handle: "${blogType}") {
                            handle
                            articles(query: ${query}, sortKey: PUBLISHED_AT, reverse: true) {
                                edges {
                                    node {
                                        image {
                                            url
                                            altText
                                        }
                                        title
                                        handle
                                    }
                                    cursor
                                }
                                pageInfo {
                                    endCursor
                                    hasNextPage
                                    hasPreviousPage
                                    startCursor
                                }
                            }
                        }
                    }`
                });

                const data = await res.json();
                if (res.ok) {
                    renderShopTheLook(data);
                }

            } catch (error) {
                console.log(error)
            }

        }

        if(filters.length) {
            filters.forEach(filter => {
                filter.addEventListener('change', () => {
                    addSelectedFilters();
                    getFilteredBlogs();
                });
            });
        }

        $(document).on('click', '.js-filter-remove', (e) => {
            e.preventDefault();
            removeSelectedFilter(e);
        });

        $(document).on('click', '.js-pagination', (e) => {
            const cursor = e.target.dataset.cursor;
            const cursorType = e.target.dataset.pagination;
            getFilteredBlogs(cursor, cursorType);
        });

        const openLookbookFiltersBtns = document.querySelectorAll('.js-toggle-lookbook-filters');
        if(openLookbookFiltersBtns.length) {
            const lookbookFilterDrawer = document.querySelector('.shop-the-look-sidebar');
            openLookbookFiltersBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    lookbookFilterDrawer.classList.toggle('open');
                });
            });
        }
        
        const headerHeight = document.querySelector('.site-header').offsetHeight;
        const stickySidebar = document.querySelector('.shop-the-look-blogs-section .grid__item--sidebar');
        if (stickySidebar) {
            stickySidebar.style.top = headerHeight + 10 + 'px';
        }
    }
    
});
// END Shop the look filters

// Tones with, etc. PDP variant functionality
// On variant change, this will change the products shown in the tabbed collection section on the PDP to show products
// that match the provided colour data
document.addEventListener('DOMContentLoaded', () => {
    let enabledPairingCollections = document.querySelectorAll('.tabbed-collection--enable-pairing');
    if (enabledPairingCollections.length > 0) {
        Papa.parse("//www.hueseeka.com.au/cdn/shop/files/pairing-data-candle.csv?v=3807814512023326413", {
            download: true,
            delimiter: ",",
            header: true,
            complete: (results) => {
                
                const init = (selectedVariant) => {
                    if (selectedVariant === "") {
                        return;
                    }
                    enabledPairingCollections.forEach(el => {
                        let pairingType = el.getAttribute('data-pairing-type');
                        for (let i=0; i<results.data.length;i++) {
                            if (results.data[i].Colour === selectedVariant) {
                                let matchedColour = results.data[i][pairingType];
                                let productGridContainers = el.querySelectorAll('.grid__item.grid-product');
                                productGridContainers.forEach( el => {
                                    let productHandle = el.getAttribute('data-product-handle');
                                    // Update images
                                    let imagesToSwap = el.querySelectorAll('image-element');
                                    imagesToSwap.forEach( img => {
                                        let imageElement = img.querySelector('img');
                                        el.querySelector('.grid-product__secondary-image').classList.add('force-show');
                                        try {
                                            imageElement.srcset = productData[productHandle][matchedColour].src;
                                        }
                                        catch (e) {
                                            console.warn("Tabbed Collection Error: Unable to replace grid images, likely colour pairing has not been defined in data csv.");
                                        }
                                    })
                                    
                                    // Update prices
                                    let priceDisplays = el.querySelectorAll('.grid-product__price .base-price');
                                    priceDisplays.forEach( price => {
                                        try {
                                            price.innerHTML = productData[productHandle][matchedColour].price;
                                        }
                                        catch (e) {
                                            console.warn("Tabbed Collection Error: Unable to update pricing display, ensure data is correct in the productData object");
                                        }
                                    })
                                    
                                    // Update URLs
                                    let urlElements = el.querySelectorAll('a');
                                    urlElements.forEach( a => {
                                        try {
                                            a.href = productData[productHandle][matchedColour].store_url;
                                        }
                                        catch (e) {
                                            console.warn("Tabbed Collection Error: Unable to change URL, ensure data is correct in the productData object");
                                        }
                                    })
                                })
                            }
                        }
                    });
                };
                
                init(enabledPairingCollections[0].getAttribute('data-selected-variant'));
                
                document.addEventListener('variant:change', (evt) => {
                    init(evt.detail.value);
                } );
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {

    const loadVariantImages = (results, colour, variant) => {
        colour = colour?.toLowerCase();
        let images = [];
        let lifeStyleImages = document.querySelectorAll(`.static-product-image img[src*='-LIFE-']`);
        if(variant.featured_media) {
            var newImage = document.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
            var imageIndex = newImage.dataset.index;
            
        } else {
            var imageIndex = variant;
        }
        var imageEl = document.querySelector(`.static-product-image[data-index="${imageIndex}"]`);

        const colourObject = results.data.find(o  => o["Colour Name"].toLowerCase() === colour);
        if(colourObject) {
            const colourCode = colourObject["Colour Code"].toUpperCase();
        
            if(colourCode) {
                images = document.querySelectorAll(`.static-product-image img[src*='-${colourCode}-`);
            }
        }
        const allImages = document.querySelectorAll('.static-product-image');
        allImages.forEach(img => {
            img.classList.add('hidden');
            img.classList.remove('image-first-position');
        })
        if(images.length) {
            images.forEach(img => {
                parent = img.closest('.static-product-image');
                parent.classList.remove('hidden');
            })
        } else {
            if(imageEl) {
                imageEl.classList.remove('hidden');
                imageEl.classList.add('image-first-position');
            }
            let imageInFirst4 = false;
            for(let i = 0; i<allImages.length; i++) {  
                if(i < (3 - lifeStyleImages.length)) {
                    allImages[i].classList.remove('hidden');
                    if(allImages[i].dataset.index == imageIndex) {
                        imageInFirst4 = true;
                    }
                } else if ((i === (3 - lifeStyleImages.length) && imageInFirst4) || (i === (3 - lifeStyleImages.length) && !imageEl)){
                    allImages[i].classList.remove('hidden');
                } else {
                    break;
                }
            }
        }
        if(lifeStyleImages.length) {
            lifeStyleImages.forEach(img => {
                parent = img.closest('.static-product-image');
                parent.classList.remove('hidden');
                parent.classList.add('lifestyle-image');
            })
        }
        const loadingParent = document.querySelector('.product__photos--grid.custom-loading');
        if(loadingParent) {
            loadingParent.classList.remove('custom-loading');
        }
    }

    const productPage = document.querySelector('body.template-product');
    if (productPage) {
        Papa.parse("//www.hueseeka.com.au/cdn/shop/files/colour_swatches.csv?v=11494696352813898455", {
            download: true,
            delimiter: ",",
            header: true,
            complete: (results) => {
                const currentColour = document.querySelector('[data-variant-color-label]')?.innerText;
                const activeStaticSlide = document.querySelector('.static-product-starting-image');
                const id = activeStaticSlide.dataset.index;
                loadVariantImages(results, currentColour, id);

                document.addEventListener('variant:change', (evt) => {
                    loadVariantImages(results, evt.detail.value, evt.detail.variant);
                } );
            }
        });
    }

    // START PDP VARIANT CHANGE EVENTS
    // - Qty max limit (Pre Order logic)
    // - Variant labels
    document.addEventListener('variant:change', (evt) => {
        const varInventoryQty = evt.detail.variant.inventory_quantity;

        // Update qty adjustor
        const qtyField = document.querySelector('.product-single__meta .js-qty__wrapper input');
        if (varInventoryQty > 0) {
            qtyField.setAttribute('max', varInventoryQty);
        } else {
            qtyField.removeAttribute('max')
        }
        document.dispatchEvent(new CustomEvent('qtyAdjustorPDP:resetMax', {detail: {max: varInventoryQty}}));

        // Update Pre Order hidden input
        const preOrderInputField = document.querySelector('#form-pre-order-input');
        if (varInventoryQty > 0) {
            preOrderInputField.setAttribute('disabled', 'disabled');
        } else {
            preOrderInputField.removeAttribute('disabled');
        }
        // Update Dispatch From hidden input
        const dispatchFromInputField = document.querySelector('#form-dispatch-from-input');
        dispatchFromInputField.value = evt.detail.variant["dispatch_from"];
        if (varInventoryQty > 0) {
            dispatchFromInputField.setAttribute('disabled', 'disabled');
        } else {
            dispatchFromInputField.removeAttribute('disabled');
        }

        // Update Inventory Quantity hidden input
        const inventoryQuantityInputField = document.querySelector('#form-inventory-qty');
        inventoryQuantityInputField.setAttribute('value', varInventoryQty);
        if (varInventoryQty > 0) {
            inventoryQuantityInputField.removeAttribute('disabled');
        } else {
            inventoryQuantityInputField.setAttribute('disabled', 'disabled');
        }

        // Update custom labels on PDP
        let newLabelData = null;

        const labelWrapper = document.querySelector('.product-single__tag-wrapper');
        labelWrapper.innerHTML = '';
        labelWrapper.classList.remove('u-mb--small');

        const labelData = document.querySelector('textarea[data-variant-tag-metafield-json');
        if (labelData) {
            const labelDataJson = JSON.parse(labelData.innerText);
            labelDataJson.forEach(obj => {
                if (obj.id === evt.detail.variant.id) {
                    newLabelData = obj.metafields;
                }
            })
        }

        if (newLabelData) {
            const newLabelDataArr = newLabelData.split('|');
            let html = '';
            newLabelDataArr.forEach(str => {
                html += `
                    <div class="product-single__tag product-single__tag--custom" style="background-color:${str.split(',')[1]}">
                        ${str.split(',')[0]}
                    </div>
                `
            })
            labelWrapper.innerHTML = html;
            labelWrapper.classList.add('u-mb--small');
        }
    } );
    // END PDP VARIANT QTY MAX LIMIT (PRE ORDER LOGIC)
});

// START COMPLETE THE LOOK
window.addEventListener('DOMContentLoaded', () => {

    const init = async () => {
        const completeTheLookSections = document.querySelectorAll('.pdp-complete-the-look');
        if (!completeTheLookSections || completeTheLookSections.length < 1) return;

        // Get collection data
        const getProductData = async (query_str) => {
            let new_query = query_str.split('OR');
            new_query = new_query.reduce((acc, cur, index) => {
                if (cur) {
                    acc = `${acc} tag:'${cur.split('-')[0].trim()}' ${index === new_query.length - 1 ? '' : 'OR'}`
                }
                return acc;
            }, '');
            let query = `
            {
                products(first: 100, query: "${new_query}") {
                    nodes {
                        availableForSale
                        title
                        handle
                        id
                        tags
                        onlineStoreUrl
                        metafields(identifiers: [{key: "", namespace: ""}]) {
                            value
                            key
                            namespace
                        }
                        images(first: 2) {
                            nodes {
                                originalSrc
                            }
                        }
                        priceRange {
                            minVariantPrice {
                                amount
                            }
                        }
                        variants(first: 10) {
                            nodes {
                                availableForSale
                                title
                                quantityAvailable
                                id
                                price {
                                    amount
                                }
                                metafields(identifiers: [{key: "retail", namespace: "discount"},{key: "stylist", namespace: "discount"},{key: "premium_stylist", namespace: "discount"},{key: "stockist", namespace: "discount"},{key: "premium_stockist", namespace: "discount"},{key: "percentage", namespace: "discount"},{key: "price_group", namespace: "custom"}]) {
                                    value
                                    key
                                    namespace
                                }
                            }
                        }
                    }
                }
            }
            `;

            var settings = {
                "url": theme.routes.storefrontAPI_test,
                "method": "POST",
                "timeout": 0,
                "headers": {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": "949d9e512aefae21c564449dfbfe09e5"
                },
                "data": JSON.stringify({
                    query: query,
                    variables: {}
                })
            };

            return $.ajax(settings).done(function (response) {
                return response;
            });
        }

        // Render collection products
        const renderProducts = async (elem = null, data = null) => {
            if (!elem || !data) return;

            let productGridItemHTML = `
                <div class="grid__item grid-product" data-product-handle="###PRODUCT_HANDLE###" data-product-id="###PRODUCT_ID###">
                    <div class="grid-product__content">
                        <div class="grid-product__label-container">
                            ###LABEL_CONTENT###
                        </div>
                        <div class="grid__item-image-wrapper">
                            <!-- Swym Wishlist Plus EPI Button with default first variant -->
                            <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_###PRODUCT_ID###" data-swaction="addToWishlist" data-product-id="###PRODUCT_ID###" data-variant-id="###VARIANT_ID###" data-product-url="###PRODUCT_URL###"></button>
                            <!-- Swym Wishlist Plus EPI Button-->
                            <a href="###PRODUCT_URL###" class="grid-product__link"></a>
                            <div class="grid-product__image-mask">
                                <a href="###PRODUCT_URL###" class="grid-product__link">
                                    <div class="grid__image-ratio grid__image-ratio--portrait">
                                        <image-element data-aos="image-fade-in" data-aos-offset="150" data-product-handle="###PRODUCT_HANDLE###" class="aos-init aos-animate">
                                            <img src="###PRODUCT_IMAGE###" alt="" loading="lazy" class="grid__image-contain image-style--image-element">
                                        </image-element>
                                    </div>
                                </a>
                                <div class="grid-product__quick-add-wrapper">
                                    ###QUICK_ADD###
                                    <a class="grid-product__quick-atc-btn" href="###PRODUCT_URL###">Shop Now</a>
                                </div>
                            </div>

                            <div class="grid-product__meta">
                                <div class="grid-product__title grid-product__title--body">
                                    ###PRODUCT_TITLE###
                                </div>
                                <div class="grid-product__price-color-wrapper">
                                    <div class="grid-product__price">
                                        <span class="base-price" data-price="###PRODUCT_PRICE_MIN_CENTS###">from $###PRODUCT_PRICE_MIN###</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            let labelContentHTML = `
                <div class="grid-product__tag grid-product__tag--custom" style="background-color:undefined">
                    ###PRODUCT_TAG_LABEL###
                </div>
            `;

            const productNodes = data?.nodes;
            if (!productNodes) return;

            let tempHTML = '';

            for (let i=0; i < productNodes.length; i++) {
                let baseVariant = null;
                let baseVarAvailable = false;
                for (let j=0; j < productNodes[i].variants.nodes.length; j++) {
                    let variant = productNodes[i].variants.nodes[j];
                    for (let k=0; k < variant.metafields.length; k++) {
                        if (variant.metafields[k]?.key == 'price_group' && variant.metafields[k]?.value.toLowerCase() == 'a') {
                            baseVariant = variant.id.split('/').slice(-1).pop();

                            if (variant.availableForSale) {
                                baseVarAvailable = true;
                            }
                        }
                    }
                }

                let tempGridItem = productGridItemHTML;
                // ###PRODUCT_URL### ???
                let label = '';
                for (let j=0; j < productNodes[i].tags.length; j++) {
                    let tag = productNodes[i].tags[j];
                    if (tag.includes('_label_')) {
                        let partial = tag.replace('_label_', '');
                        label +=labelContentHTML.replace('###PRODUCT_TAG_LABEL###', partial);
                    }
                }
                const title = productNodes[i].title;
                const handle = productNodes[i].handle;
                const id = productNodes[i].id.split('/').slice(-1).pop();
                const url = productNodes[i].onlineStoreUrl;
                const images = productNodes[i].images.nodes;
                const img_1 = images[0]?.originalSrc;
                const img_2 = images[1]?.originalSrc;
                const price_min = parseFloat(productNodes[i].priceRange.minVariantPrice.amount).toFixed(2);

                let quickAddHTML = '';
                if (baseVariant && baseVarAvailable) {
                    quickAddHTML = `
                        <button class="grid-product__quick-atc-btn" type="button" data-id="${baseVariant}" data-prod-id="${id}">Quick Add</button>
                    `;
                }

                tempGridItem = tempGridItem.replaceAll('###PRODUCT_TITLE###', title);
                tempGridItem = tempGridItem.replaceAll('###PRODUCT_HANDLE###', handle);
                tempGridItem = tempGridItem.replaceAll('###PRODUCT_ID###', id);
                tempGridItem = tempGridItem.replaceAll('###LABEL_CONTENT###', label);
                if (url) {
                    tempGridItem = tempGridItem.replaceAll('###PRODUCT_URL###', url);
                } else {
                    tempGridItem = tempGridItem.replaceAll('###PRODUCT_URL###', `/products/${handle}`);
                }
                tempGridItem = tempGridItem.replaceAll('###PRODUCT_IMAGE###', img_1);
                tempGridItem = tempGridItem.replaceAll('###PRODUCT_SECONDARY_IMAGE###', img_2);
                tempGridItem = tempGridItem.replaceAll('###PRODUCT_PRICE_MIN###', price_min);
                tempGridItem = tempGridItem.replaceAll('###PRODUCT_PRICE_MIN_CENTS###', price_min * 100);

                tempGridItem = tempGridItem.replaceAll('###QUICK_ADD###', quickAddHTML);

                // Add grid item to HTML
                tempHTML += tempGridItem;
            }

            // Add all grid items to element
            elem.innerHTML = tempHTML;

            initCustomSlider(elem)
        }

        // START HERE
        completeTheLookSections.forEach(async elem => {
            const query_str = elem.getAttribute('data-query-str');
            const productData = await getProductData(query_str);
            if (!productData?.data?.products) return;

            renderProducts(elem, productData.data.products);
        });
    }
    init();
})
// END COMPLETE THE LOOK

// START REINIT WISHLIST
document.addEventListener('collection:reloaded', () => {
    if (window.SwymCallbacks) {
        SwymCallbacks.push(function() {
            window._swat.initializeActionButtons("body");
        });
    }
})
// END REINIT WISHLIST